<template>
  <div :class="[`view-451`, className || ``]">
    <div class="view-452">
      <div class="rectangle-85"></div>
      <div class="x1-51">
        <p class="text-466 roboto-bold-bunker-20px">Курс: Обучение 1С и Битрикс</p>
        <div class="x1-52">
          <div class="view-453">
            <div class="rectangle-203"></div>
            <div class="text-464 poppins-bold-white-20px">Присоединиться</div>
          </div>
          <div class="text-465 poppins-normal-thunder-20px">12:00</div>
          <div class="date poppins-normal-thunder-20px">02.09.25</div>
        </div>
        <x292 :text1754="x291Props.text1754" :date="x291Props.date" />
        <x292 :text1754="x292Props.text1754" :date="x292Props.date" :className="x292Props.className" />
      </div>
      <div class="text-467 centurygothic-bold-thunder-25px">Онлайн конференции</div>
    </div>
    <div class="view-454">
      <div class="rectangle-85-1"></div>
      <div class="view-455">
        <div class="text-443 poppins-semi-bold-thunder-20px">Статус</div>
        <div class="text-444 poppins-semi-bold-thunder-20px">Задания</div>
        <div class="text-445 poppins-semi-bold-thunder-20px">Дедлайн</div>
        <div class="group-473">
          <p class="text-447 poppins-normal-thunder-17px-2">ДЗ 04: Создание первой карточки товара</p>
          <view472 />
        </div>
        <group47122
          :text1741="group47121Props.text1741"
          :text1740="group47121Props.text1740"
          :view48Props="group47121Props.view48Props"
        />
        <group47122
          :text1741="group47122Props.text1741"
          :text1740="group47122Props.text1740"
          :className="group47122Props.className"
          :view48Props="group47122Props.view48Props"
        />
        <div class="group-472">
          <p class="text-455 poppins-normal-thunder-17px-2">ДЗ 05: Создание первой карточки товара</p>
          <view472 />
        </div>
        <div class="group-470">
          <p class="text-458 poppins-normal-thunder-17px">ДЗ 01: Создание первой карточки товара</p>
          <div class="text-457 poppins-normal-thunder-20px">20.08.25 21:00</div>
          <view482 />
        </div>
      </div>
      <div class="text-459 centurygothic-bold-thunder-25px">Домашние задания</div>
    </div>
    <div class="view-456">
      <div class="rectangle-85-2"></div>
      <div class="x1-53 poppins-normal-thunder-25px">
        <div class="x1-54">
          <div class="text-441">Модуль 6</div>
          <div class="text-440">08.09.25, понедельник</div>
        </div>
        <x2102 :text1730="x2101Props.text1730" :text1729="x2101Props.text1729" />
        <x3102 :text1728="x3101Props.text1728" :text1727="x3101Props.text1727" />
        <x3102 :text1728="x3102Props.text1728" :text1727="x3102Props.text1727" :className="x3102Props.className" />
        <x2102 :text1730="x2102Props.text1730" :text1729="x2102Props.text1729" :className="x2102Props.className" />
        <div class="x2-15">
          <div class="text-431">Финальный тест</div>
          <div class="text-430">13.09.25, понедельник</div>
        </div>
      </div>
      <div class="text-442 centurygothic-bold-thunder-25px">График выхода модулей</div>
    </div>
  </div>
</template>

<script>
import X292 from "./X292";
import View472 from "./View472";
import Group47122 from "./Group47122";
import View482 from "./View482";
import X2102 from "./X2102";
import X3102 from "./X3102";
export default {
  name: "View802",
  components: {
    X292,
    View472,
    Group47122,
    View482,
    X2102,
    X3102,
  },
  props: [
    "className",
    "x291Props",
    "x292Props",
    "group47121Props",
    "group47122Props",
    "x2101Props",
    "x3101Props",
    "x3102Props",
    "x2102Props",
  ],
};
</script>

<style>
.view-451 {
  background-image: url(https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/rectangle-12.svg);
  background-size: 100% 100%;
  display: flex;
  height: 566px;
  left: 0;
  position: absolute;
  top: 1995px;
  width: 1920px;
}

.view-452 {
  height: 403px;
  margin-left: 25px;
  margin-top: 82px;
  position: relative;
  width: 489px;
}

.rectangle-85 {
  background-color: var(--white);
  border: 1px solid;
  border-color: var(--storm-dust-3);
  border-radius: 20px;
  height: 403px;
  left: 0;
  position: absolute;
  top: 0;
  width: 487px;
}

.x1-51 {
  display: flex;
  flex-direction: column;
  height: 215px;
  left: 11px;
  position: absolute;
  top: calc(50% - 108px);
  width: 467px;
}

.text-466 {
  height: 23px;
  letter-spacing: 2px;
  line-height: normal;
  margin-left: 30px;
  margin-top: 17px;
  white-space: nowrap;
  width: 327px;
}

.x1-52 {
  display: flex;
  margin-left: 29px;
  margin-top: 18px;
  width: 430px;
}

.view-453 {
  align-self: center;
  height: 40px;
  position: relative;
  width: 207px;
}

.rectangle-203 {
  background-color: var(--shamrock);
  border-radius: 10px;
  height: 40px;
  left: 0;
  position: absolute;
  top: calc(50% - 20px);
  width: 205px;
}

.text-464 {
  left: 14px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 5px;
}

.text-465 {
  height: 30px;
  letter-spacing: 1px;
  line-height: normal;
  margin-left: 48px;
  margin-top: 5px;
  width: 52px;
}

.date {
  height: 30px;
  letter-spacing: 1px;
  line-height: normal;
  margin-left: 30px;
  margin-top: 5px;
  width: 89px;
}

.text-467 {
  left: 53px;
  letter-spacing: 1.75px;
  line-height: normal;
  position: absolute;
  top: 17px;
}

.view-454 {
  height: 401px;
  margin-left: 20px;
  margin-top: 84px;
  position: relative;
  width: 717px;
}

.rectangle-85-1 {
  background-color: var(--white);
  border: 1px solid;
  border-color: var(--storm-dust-3);
  border-radius: 20px;
  height: 401px;
  left: 0;
  position: absolute;
  top: 0;
  width: 715px;
}

.view-455 {
  height: 289px;
  left: 23px;
  position: absolute;
  top: 58px;
  width: 679px;
}

.text-443 {
  left: 563px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 0;
}

.text-444 {
  left: 2px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 0;
}

.text-445 {
  left: 411px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 0;
}

.group-473 {
  display: flex;
  gap: 177px;
  height: 40px;
  left: 0;
  position: absolute;
  top: 197px;
  width: 675px;
}

.text-447 {
  height: 26px;
  letter-spacing: 0;
  line-height: normal;
  margin-top: 0.3px;
  width: 346px;
}

.group-472 {
  display: flex;
  gap: 177px;
  height: 40px;
  left: 0;
  position: absolute;
  top: 249px;
  width: 675px;
}

.text-455 {
  height: 26px;
  letter-spacing: 0;
  line-height: normal;
  margin-top: 2.3px;
  width: 346px;
}

.group-470 {
  display: flex;
  height: 40px;
  left: 0;
  position: absolute;
  top: 41px;
  width: 677px;
}

.text-458 {
  height: 26px;
  letter-spacing: 0;
  line-height: normal;
  margin-top: 5.3px;
  width: 341px;
}

.text-457 {
  height: 30px;
  letter-spacing: 0;
  line-height: normal;
  margin-left: 31px;
  margin-top: 5.3px;
  width: 135px;
}

.text-459 {
  left: 25px;
  letter-spacing: 1.75px;
  line-height: normal;
  position: absolute;
  top: 12px;
}

.view-456 {
  height: 400px;
  margin-left: 43px;
  margin-top: 83px;
  position: relative;
  width: 601px;
}

.rectangle-85-2 {
  background-color: var(--white);
  border: 1px solid;
  border-color: var(--storm-dust-3);
  border-radius: 20px;
  height: 400px;
  left: 0;
  position: absolute;
  top: 0;
  width: 599px;
}

.x1-53 {
  display: flex;
  flex-direction: column;
  gap: 15px;
  height: 303px;
  left: 25px;
  position: absolute;
  top: 63px;
  width: 549px;
}

.x1-54 {
  display: flex;
  gap: 51px;
  margin-left: 67px;
  width: 486px;
}

.text-441 {
  height: 38px;
  letter-spacing: 1.25px;
  line-height: normal;
  width: 126px;
}

.text-440 {
  height: 38px;
  letter-spacing: 1.25px;
  line-height: normal;
  width: 305px;
}

.x2-15 {
  display: flex;
  gap: 18px;
  width: 544px;
}

.text-431 {
  height: 38px;
  letter-spacing: 1.25px;
  line-height: normal;
  width: 226px;
}

.text-430 {
  height: 38px;
  letter-spacing: 1.25px;
  line-height: normal;
  width: 296px;
}

.text-442 {
  left: 78px;
  letter-spacing: 1.75px;
  line-height: normal;
  position: absolute;
  top: 16px;
}

.view-451.view-457 {
  left: unset;
  margin-top: 39px;
  position: unset;
  top: unset;
}
</style>
